<template>
    <footer v-if="footer" id="footer">
        <div class="container">
            <div class="footer-pages">
                <div class="in-view" data-animation="in-view-scale" v-for="page in footer.collections[0].pages" :key="page.id" v-html="page.content"></div>
                <div class="copyright in-view" data-animation="in-view-scale">
                    <!-- <a href="https://une.ch" target="_blank"><img src="/images/une.svg" alt=""></a> -->
                    <p>© {{ new Date().getFullYear() }} Ashenden Finance SA</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import {mapState} from 'vuex'
import _find from 'lodash/find'
    export default {
        data () {
            return {
            }
        },
        methods: {
        },
        computed: {
            ...mapState([
                'sections'
            ]),
            footer() {
                return _find(this.sections, {type: 'footer'})
            }
        }
    }
</script>